<mat-card>
  <dashboard-management-information [userTier]="this.usersService.tier"></dashboard-management-information>
</mat-card>
<div class="fx-layout-row fx-gap-10 cases-row">
  <div class="fx-flex-50 cases-col">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="My Open Cases">
        <mat-card class="activity-card">
          <case-list [activityLevel]="4"></case-list>
        </mat-card>
      </mat-tab>
      <mat-tab label="My Notifications">
        <mat-card class="activity-card">
         <activity-list [noItemsMessage]="'You currently have no Notifications.'" [activityLevel]="4"></activity-list>
        </mat-card>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="fx-flex-50">
    <dashboard-card-link-list></dashboard-card-link-list>
  </div>
</div>